import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ApiResponse } from 'src/app/shareModule/models/common.model';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { CommonService } from 'src/app/shareModule/services/common.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-member-bulletin',
  templateUrl: './member-bulletin.component.html',
  styleUrls: ['./member-bulletin.component.scss']
})
export class MemberBulletinComponent implements OnInit {


  @ViewChild("AssignOption") AssignOptionModal: ElementRef;
  @ViewChild("AddNews") addEventModal: ElementRef;

  @Input() hideAll: boolean = false;

  public editMode: boolean;
  public commonModal: any;
  public allNews: Array<any> = [];
  public selectedAds: any;
  public imageBase64: string | ArrayBuffer;
  public imgUrl = environment.ImageUrl;

  public categoriesList: Array<any> = [];
  public subRegionList: Array<any> = [];
  public selectedArticle: any = null;

  public form: FormGroup = new FormGroup({
    text: new FormControl("", [Validators.required]),
  });


  constructor(private toastr: ToastrService, private modalService: NgbModal, private auth: AuthServiceService, public commonService: CommonService) { }

  ngOnInit(): void {
    this._getAdsList();
  }

  public openProductCharForAddEdit(selected: any = null) {
    if (selected) {
      this.editMode = true;
      this.selectedAds = selected;
      this.form.patchValue({
        text: selected?.text,
      });
    } else {
      this.form.reset();
    }
    this.commonModal = this.modalService.open(this.addEventModal, {
      size: "xs",
      backdrop: "static",
      windowClass: "suggestion",
    });
  }

  public modalDismissAll() {
    this.modalService.dismissAll();
    this.selectedAds = null;
  }

  public save(): void {
    if (this.form.valid) {
      let formData = new FormData();
      formData.append("text", this.form.get("text").value);

      // formData.append("subRegion", 'default');

      if (this.selectedAds) {
        formData.append("id", this.selectedAds?.id);
      }
      this.auth.bulletin_store(formData).subscribe((resp: ApiResponse) => {
        this.toastr.success(resp.message);
        this.modalDismissAll();
        this._getAdsList();
        this.selectedAds = null;
      }, ({ error }: any) => {
        this.toastr.error(error.message);
      });
    } else {
      this.toastr.error("Form is Invalid fill ALL ");
    }
  }

  private _getAdsList() {
    this.auth.bulletin_fetch().subscribe((resp: ApiResponse) => {
      this.allNews = resp.body?.data ?? [];
    });
  }

  public deleteAds(id) {
    this.auth.bulletin_delete(id).subscribe((resp: ApiResponse) => {
      this.toastr.success(resp.message);
      this._getAdsList();
    });
  }
}
